import api from "./api";

const ramaService = {
  obterPorSolicitacao: async (solicitacaoId) => {
    const response = await api.get(`Rama/solicitacao/${solicitacaoId}`);
    return response.data?.data ?? response.data;
  },

  enviar: async (entregaId, arquivo) => {
    const formData = new FormData();
    formData.append("arquivo", arquivo);
    const response = await api.post(`Rama/entrega/${entregaId}/enviar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  aprovar: async (versaoId) => {
    const response = await api.post(`Rama/versao/${versaoId}/aprovar`);
    return response.data;
  },

  reprovar: async (versaoId, motivo) => {
    const response = await api.post(`Rama/versao/${versaoId}/reprovar`, { motivo });
    return response.data;
  },
};

export default ramaService;
